import React from "react";
import DatePicker from "react-datepicker";
import MaskedInput from "react-text-mask";
import Switch from "@material-ui/core/Switch";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import "react-datepicker/dist/react-datepicker.css";
// component
import { HintField, LabelField } from "components";
import { getDateFormatForDatePicket } from "helper/dateFormat";
import createAutoCorrectedDatePipe from "text-mask-addons/dist/createAutoCorrectedDatePipe";
// direct import
import "../../../DateTime/DateStyle.scss";
import { fontConfig } from "theme/fontConfig";
export const DateTimePickerField = ({
  myStyle,
  memberInfo,
  title,
  name,
  style,
  type,
  rules,
  error,
  formik,
  checkValidation = false,
  mandatory = false,
  alwaysAvailable = false,
  checkAvailableHandler,
  action,
  index,
  handleChange,
  value,
  minDate,
  maxDate,
  minTime = null,
  maxTime = null,
  disabled,
  onChange,
  selected,
  showTimeSelect,
  dateFormat,
  placeholderText,
  mask,
  getTouch,
  ...rest
}) => {
  const autoCorrectedDatePipe = createAutoCorrectedDatePipe(
    getDateFormatForDatePicket() || "mm/dd/yyyy"
  );

  return (
    <div
      className={
        memberInfo
          ? "form-group fv-plugins-icon-container datepicker-caontainer member-info-date"
          : "form-group fv-plugins-icon-container datepicker-caontainer"
      }
    >
      <div
        className="d-flex align-items-center justify-content-between"
        style={{ height: "27px" }}
      >
        <div className="d-flex">
          <LabelField
            htmlFor={name}
            title={title}
            className={memberInfo ? "member-info-date-lable" : ""}
            style={{
              fontFamily: fontConfig.GeneralMemberInfoDateLableFont.family,
              fontWeight: "400",
              fontSize: "12px",
              lineHeight: "18px",
              color: "#4F4F4F",
            }}
          />
          {mandatory && (
            <label style={{ fontWeight: "500", color: "red" }} {...rest}>
              {" *"}
            </label>
          )}
        </div>
        {alwaysAvailable && (
          <div className="col-sm-6 d-flex justify-content-end align-items-center p-0 mb-2">
            <div className="col d-flex justify-content-end text-nowrap">
              Always Available
            </div>
            <FormControlLabel
              control={
                <Switch
                  checked={formik.values?.alwaysAvailable}
                  onChange={checkAvailableHandler}
                  inputProps={{ "aria-label": "primary checkbox" }}
                />
              }
              style={{ margin: "0px" }}
            />
          </div>
        )}
      </div>
      <div className={memberInfo ? "d-flex member-info-date-input" : "d-flex"}>
        <DatePicker
          showTimeSelect={showTimeSelect || false}
          isClearable
          showIcon
          dateFormat={dateFormat || "MM/dd/yyyy"}
          placeholderText={placeholderText || "MM/DD/YYYY"}
          selected={selected}
          onChange={onChange}
          minDate={minDate}
          maxDate={maxDate}
          minTime={minTime}
          maxTime={maxTime}
          disabled={disabled}
          customInput={
            <MaskedInput
              pipe={autoCorrectedDatePipe}
              mask={
                mask || [
                  /\d/,
                  /\d/,
                  "/",
                  /\d/,
                  /\d/,
                  "/",
                  /\d/,
                  /\d/,
                  /\d/,
                  /\d/,
                ]
              }
              keepCharPositions={true}
              guide={true}
            />
          }
        />
      </div>
      {getTouch && error ? <HintField error={error} /> : null}
    </div>
  );
};
